import { Typography } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import BoldText from 'components/BoldText';

import useStyles from './FrameDetailsListItem.styles';

type FrameDetailsListItemProps = {
  prefix: string;
  frameDetail: string | undefined | null;
  nextFrameDetail: string | undefined | null;
};

const FrameDetailsListItem = ({
  prefix,
  frameDetail,
  nextFrameDetail,
}: FrameDetailsListItemProps) => {
  const classes = useStyles();

  return (
    frameDetail && (
      <>
        <Typography variant="body2">
          {prefix}: <BoldText text={frameDetail} />
        </Typography>
        {!!nextFrameDetail && <span data-testid="separator" className={classes.separator} />}
      </>
    )
  );
};

export default FrameDetailsListItem;
